const testimonials = [
  {
    name: "Carol M.",
    location: "St. Petersburg, FL",
    rating: 5,
    text: "We booked a Dali Museum trip to Spain and realized my husband's passport expired two weeks before departure. Fast Passport Center got his renewal done in 4 days. We made our Barcelona gallery tour without a hitch.",
    service: "Passport Renewal",
  },
  {
    name: "David R.",
    location: "Clearwater, FL",
    rating: 5,
    text: "Cruise from Port Tampa Bay in 10 days and my daughter's passport was nowhere to be found. I called FPC in a panic and they walked me through the child passport process, got us an acceptance clerk appointment in Pinellas Park, and had her passport in 6 days. Absolute lifesavers.",
    service: "Child Passport",
  },
  {
    name: "Jennifer L.",
    location: "St. Pete Beach, FL",
    rating: 5,
    text: "I'm a nurse at Bayfront Health and my schedule is crazy. I needed my passport renewed for a trip to the Bahamas and had zero time to deal with paperwork. FPC handled everything — I shipped my documents on a Tuesday and had my passport by Friday. Could not recommend them more.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function StPetersburgTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What St. Petersburg Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across St. Petersburg, Clearwater, and Pinellas County who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}